import { Component, OnInit, HostListener } from '@angular/core';
import {ApiService} from "../app.service";
import { DomSanitizer } from '@angular/platform-browser'

@Component({
	selector: 'app-intro',
	templateUrl: './intro.component.html',
	styleUrls: ['./intro.component.scss']
})
export class IntroComponent implements OnInit {

	constructor(public api:ApiService,private sanitized: DomSanitizer) { }

	html:any;
	showModal:boolean = false;
	navbarCollapsed:boolean = false;

	@HostListener('window:scroll', [])
	onWindowScroll() {
		this.navbarCollapsed = window.pageYOffset > 100;
	}

	ngOnInit() {	
		this.api.post("spdo=select",{database:'html',where:"id_html = 1"}).then((res:any)=>{
			this.html = this.sanitized.bypassSecurityTrustHtml(res.data[0].content);
		});
		let i = 1;
		// setTimeout(()=>{
		// 	setInterval(()=>{
		// 		i++;
		// 		let el = document.querySelector("#jarallax-container-0").children[0];
		// 		el.style.backgroundImage = "url(/assets/img/slide"+i+".jpg)";
		// 		if(i === 3)
		// 			i = 0;
		// 	},1500);
		// },2000)
		
	}

}
